import { render, staticRenderFns } from "./open_approve_incident.vue?vue&type=template&id=71bbab6a"
import script from "./open_approve_incident.vue?vue&type=script&lang=js"
export * from "./open_approve_incident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports